import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { ShippingLine } from 'src/app/core/models/shipping-line';
import { ShippingLineService } from 'src/app/core/services/general/shipping-line.service';

@Component({
  selector: 'app-shipping-line-input',
  templateUrl: './shipping-line-input.component.html',
  styleUrls: ['./shipping-line-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ShippingLineInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: ShippingLineInputComponent,
    },
  ],
})
export class ShippingLineInputComponent {
  @Input()
  title = "Select Shipping Line...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public shippingLinesList: Array<CustomSelectOption> = [];

  constructor(
    private shippingLineService: ShippingLineService,
  ) {
    this.shippingLineService
      .all()
      .subscribe((res: Array<ShippingLine>) => {
        this.shippingLinesList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.shippingLinesList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
